var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-autocomplete", {
    attrs: {
      items: _vm.items,
      "item-text": "key",
      "item-value": "key",
      label: _vm.label,
      clearable: _vm.clearable,
      "hide-details": "",
    },
    on: {
      "update:items": function ($event) {
        _vm.items = $event
      },
    },
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v
      },
      expression: "selected",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }